export default "__VITE_ASSET__HyjhM_fX__"